//import
import React, { useEffect, useState } from 'react';
import { Tag, Table, Space, Button, Input, Pagination, Modal, Card } from 'antd';
import { GetAllPayments, GetAllRetreats } from '../../../api/AdminService';
import { Link } from 'react-router-dom';
import LoadingPage from '../../../Components/LoadingPage/LoadingPage';

const AdminPayment = () => {
  const [loading, setLoading] = useState(true);
  const [dataSrc, setDataSrc] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [customerEmail, setCustomerEmail] = useState('');
  const [totalPage, setTotalPage] = useState(0);
  const titleStyle = { color: '#4A5568' };
  const [open, setOpen] = useState(false);
  const [DetailPayment, setDetailPayment] = useState(null);

  const columns = [
    {
      title: <span style={titleStyle}>Retreat Name</span>,
      dataIndex: 'retreatName',
      key: 'retreatName',
    },
    {
      title: <span style={titleStyle}>Customer Name</span>,
      dataIndex: 'customerName',
      key: 'customerName',
    },
    {
      title: <span style={titleStyle}>Customer Email</span>,
      dataIndex: 'customerEmail',
      key: 'customerEmail',
    },
    {
      title: <span style={titleStyle}>Payment Method</span>,
      dataIndex: 'paymentMethod',
      key: 'paymentMethod',
    },
    {
      title: <span style={titleStyle}>Date</span>,
      dataIndex: 'createAt',
      key: 'createAt',
      render: (date) => {
        const formattedDate = new Date(date).toISOString().split('T')[0]; // Format date to YYYY-MM-DD
        return formattedDate;
      },
    },
    {
      title: <span style={titleStyle}>Status</span>,
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        let color;
        let text;
        if (status === 'Success') {
          color = 'green';
          text = 'Success';
        } else if (status === 'Refunded') {
          color = 'blue';
          text = 'Refunded';
        } else if (status === 'Pending') {
          color = 'gray';
          text = 'Pending';
        } else if (status === 'Cancel') {
          color = 'gray';
          text = 'Cancel';
        } else if (status === 'Fail') {
          color = 'red';
          text = 'Fail';
        }
        return (
          <Tag color={color}>
            {text}
          </Tag>
        );
      },
    },
    {
      title: <span style={titleStyle}>Action</span>,
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Link>
            <Button type="primary" onClick={() => { setOpen(true); setDetailPayment(record) }}>
              Detail
            </Button>
          </Link>
        </Space>
      ),
    },
  ]

  const getPayments = () => {
    try {
      GetAllPayments(customerEmail).then(res => {
        if (res.status === 200) {
          console.log(res.data);
          setDataSrc(res.data);
          setLoading(false);
          setTotalPage(res.data.length);
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getPayments(currentPage - 1);
  }, [currentPage, customerEmail]);

  const paginatedData = dataSrc.slice((currentPage - 1) * 12, currentPage * 12);

  return (
    <div
      style={{
        padding: 24,
        minHeight: '96.5vh',
        Width: '100vh',
      }}
    >
      <h1 style={{ fontSize: '2.5rem', marginBottom: 16, fontWeight: 'bold', textAlign: 'left', color: '#003366' }}>ALL PAYMENTS</h1>

      {loading ? (<LoadingPage />
      ) : (
        <>
          <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <Input
                placeholder="Search by Customer Email"
                value={customerEmail}
                onChange={(e) => setCustomerEmail(e.target.value)}
                style={{ width: '200px', marginRight: '8px' }}
              />
            </div>

            <Pagination
              current={currentPage}
              pageSize={12}
              total={totalPage}
              onChange={(page) => setCurrentPage(page)}
              showSizeChanger={false}
            />
          </div>
          <Table columns={columns} dataSource={paginatedData} pagination={false} />
          <Modal
            title={<div style={{fontSize:20}}>Transaction Bill</div>}
            centered
            open={open}
            onCancel={() => setOpen(false)}
            footer={null}
          >
            {DetailPayment && ( // Render selected record details
              <div>
                <Card title={'Customer Information'} style={{marginBottom:16}}>
                  <p><strong> Name:</strong> {DetailPayment.customerName}</p>
                  <p><strong> Email:</strong> {DetailPayment.customerEmail}</p>
                  <p><strong> Phone:</strong> {DetailPayment.account.phoneNumber}</p>
                </Card>
                <Card title={'Retreat Information'} style={{marginBottom:16}}>
                  <p><strong>Retreat Name:</strong> {DetailPayment.retreatName}</p>
                  <p><strong>Tution Fee:</strong> {DetailPayment.amount}</p>
                </Card>
                <Card title={'Bill Information'} style={{marginBottom:16}}>
                  <p><strong>Payment ID:</strong> {DetailPayment.id}</p>
                  <p><strong>Date:</strong> {new Date(DetailPayment.createAt).toISOString().split('T')[0]}</p>
                  <p><strong>Status:</strong> {DetailPayment.status}</p>
                </Card>

              </div>
            )}
          </Modal>
        </>)}
    </div>
  );
};

export default AdminPayment;